import React, { Component } from 'react';
import qs from 'qs'
import axios from '../../axios'
import Alert from 'react-s-alert'
import CustomModal from '../../components/CustomModal.js'
import { dateIndo } from '../../functions/functionGeneral'

class Bill extends Component {
    
    constructor() {
        super()

        this.state = {
            dataBills: [],
            spp_id: 0,
            isLoading: true,
            isModalShow: false,
        }

        this.toggleModal = this.toggleModal.bind(this)
        this.handleSubmitModal = this.handleSubmitModal.bind(this)
    }

    toggleModal() {
        this.setState({ isModalShow: !this.state.isModalShow })
    }

    handleSubmitModal() {

        const params = qs.stringify({
            spp_status: "1",
            spp_id: this.state.spp_id
        })

        axios({
            method: 'post',
            url: '/spp/status?' + params
        })
        .then(response => {

            Alert.success("Data berhasil diperbarui");

            this.loadData();
            this.toggleModal();

            return;
        })
        .catch(error => {
            console.log(error)
            this.setState({isLoading: false})
            Alert.error("Gagal terhubung ke server!")
        })
    }

    loadData() {

        this.setState({ isLoading: true })

        axios.post("/spp")
            .then(response => {

                const result = response.data

                this.setState({
                    dataBills: result.data,
                    isLoading: false
                })
            })
            .catch((error) => {

                console.log(error)

                this.setState({ isLoading: false })

                Alert.error("Gagal terhubung ke server!")
            })
    }

    componentDidMount() {

        this.loadData()
    }

    render() {
        
        return (
            <div className="col-sm-12">

                <CustomModal
                    isShow={this.state.isModalShow}
                    toggleModal={this.toggleModal}
                    handleSubmit={this.handleSubmitModal}
                    modalHeaderText="Konfirmasi"
                    modalBodyText="Anda yakin tagihan ini telah dibayar?"
                    modalSubmitText="Ya" />
                    
                <div className="card">
                    <div className="card-header">
                        Fee & Bill
                    </div>
                    <div className="card-block">
                        {
                            this.state.isLoading ? "Memuat Data..." : (
                                this.state.dataBills.length === 0 ? "Data Kosong..." : (
                                    <div>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Bulan</th>
                                                    <th>Tahun</th>
                                                    <th>Status Pembayaran</th>
                                                    <th>Opsi</th>
                                                </tr>
                                            </thead>
                                            <tbody> 
                                                {
                                                    this.state.dataBills.map((item, i) => {

                                                        return (
                                                            <tr key={i}>
                                                                <td>{item.spp_month}</td>
                                                                <td>{item.spp_year}</td>
                                                                <td>
                                                                    {
                                                                        item.spp_status === "0" ? "Belum Lunas" : 
                                                                            <span>
                                                                                Lunas <br /> 
                                                                                <small><b>Tanggal Konfirmasi: { dateIndo(item.spp_paid_date) }</b></small>
                                                                            </span>
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        item.spp_status === "0" ? (
                                                                            <button 
                                                                                type="button"
                                                                                className="btn btn-primary btn-sm"
                                                                                onClick={() => {
                                                                                    this.toggleModal();
                                                                                    this.setState({ spp_id: item.spp_id });
                                                                                }}
                                                                            >
                                                                                <i className="fa fa-check"></i> {" "}
                                                                                Set Lunas
                                                                            </button>
                                                                        ) : "-"
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Bill;


// WEBPACK FOOTER //
// ./src/views/Users/Bill.js